
import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";

const BouncingObject = () => {
  const objectRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to(objectRef.current, {
        y: -80,
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut"
      });
      gsap.to(objectRef.current, {
        x: 25,
        duration: 4,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <div className="flex justify-center mb-8 md:mb-20 mt-24 md:mt-20">
      <img 
        ref={objectRef}
        src="/lovable-uploads/38f05a97-469e-4e42-af3b-55c9e2b8c491.png" 
        alt="Metallic crumpled object" 
        className="bouncing-metal w-32 h-32 md:w-40 md:h-40 object-contain" 
      />
    </div>
  );
};

export default BouncingObject;
